<template>
    <van-field
        class="van-field-radio"
        :value="this[this.paramName]"
        :name="paramName"
        :required="required"
        :label="label"
        :rules="rules"
        readonly
        :disabled="disabled"
    >
        <template #input>
            <van-radio-group
                v-model="lwwRadio"
                :disabled="disabled"
                direction="horizontal"
                @change="onChange"
            >
                <van-radio v-for="item in options" :key="item.value" :name="item.value">{{
                    item.label
                }}</van-radio>
            </van-radio-group>
        </template>
    </van-field>
</template>
<script>
export default {
    props: {
        options: {
            type: Array,
            default: () => {
                return []
            }
        },
        rules: {
            type: Array,
            default: () => {
                return []
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        },
        initValue: {
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        paramName: {
            type: String,
            default: ''
        },
        defaultIndex: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            [this.paramName]: this.initValue,
            lwwRadio: this.initValue
        }
    },
    watch: {
        initValue(newVal) {
            this[this.paramName] = newVal
            this.lwwRadio = newVal
        }
    },
    methods: {
        onChange(name) {
            this[this.paramName] = name
        }
    },
    mounted() {
        if (this.initValue === '' || this.initValue == undefined) {
            if (this.options.length > 0) {
                this.lwwRadio = this.options[this.defaultIndex].value
                this[this.paramName] = this.options[this.defaultIndex].value
            }
        }
    }
}
</script>
<style lang="less"></style>
